import React from 'react';

export default (props) => {
	return (
		<article className='job'>

			<p className='title'> {props.job.title} </p>
			<p className='company'> {props.job.company} </p>
			<p className='date'> {props.job.dates} </p>
			<ul className='description'>
				{
					props.job.description.map((elem, index) => (
						<li key={index}> {elem}</li>
					))
				}
			</ul>
		</article>
	);
}